/* ==========================================================================
   AJ CLOTHING — storefront behaviour
   Ported from the approved mockup, wired to real Shopify endpoints:
     /cart.js, /cart/add.js, /cart/change.js and /search/suggest.json
   Config (routes, currency, strings) is injected by snippets/aj-scripts.liquid
   as window.AJ before this file runs.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.AJ || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* --------------------------------------------------------------- money */
  var fmt;
  try {
    fmt = new Intl.NumberFormat(CFG.locale || 'en-AU', {
      style: 'currency',
      currency: CFG.currency || 'AUD',
      minimumFractionDigits: 2
    });
  } catch (e) { fmt = null; }
  function money(cents) {
    var v = (cents || 0) / 100;
    return fmt ? fmt.format(v) : '$' + v.toFixed(2);
  }

  /* --------------------------------------------------------------- toast */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'aj-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2200);
  }

  /* ------------------------------------------------------ announcement */
  function initAnnounce() {
    $$('.aj-announce__rot').forEach(function (rot) {
      var msgs = $$('.aj-announce__msg', rot);
      var speed = parseInt(rot.getAttribute('data-speed'), 10) || 4200;
      if (msgs.length < 2 || rot.getAttribute('data-rotate') === 'false') return;
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ------------------------------------------------------------ scroller
     Horizon sets html/body to overflow:hidden and scrolls .page-wrapper
     instead, so scroll listeners and scroll-locking must target that.
     It only does this on larger screens though — below the breakpoint it
     hands scrolling back to the document, and .page-wrapper's scrollTop is
     then permanently 0. Resolve it per call by asking whether the element
     actually scrolls, so scroll position, the scroll listener and the drawer
     scroll-lock all follow whichever element is really in charge. */
  function scroller() {
    var pw = document.querySelector('.page-wrapper');
    return pw && pw.scrollHeight > pw.clientHeight + 1 ? pw : null;
  }
  function scrollTop() {
    var sc = scroller();
    return sc ? sc.scrollTop : (window.scrollY || document.documentElement.scrollTop || 0);
  }
  function lockScroll(on) {
    var sc = scroller() || document.documentElement;
    sc.style.overflow = on ? 'hidden' : '';
  }

  /* ----------------------------------------------------- sticky header */
  function initHeader() {
    var header = $('.aj-header');
    if (!header) return;
    var group = document.getElementById('header-group');
    var announce = $('.aj-announcement-section') || $('.aj-announce');

    function sync() {
      header.classList.toggle('is-stuck', scrollTop() > 8);
      document.body.style.setProperty('--aj-header-height', header.offsetHeight + 'px');
      // #header-group is stuck at -(announcement height) so the bar scrolls
      // away and the nav pins at 0. Measured live because the announcement can
      // be hidden, restyled or wrap to two lines on a narrow screen.
      if (group) {
        var annH = announce && announce.offsetParent !== null ? announce.offsetHeight : 0;
        group.style.setProperty('--aj-announce-h', annH + 'px');
      }
    }
    // Which element scrolls flips at the breakpoint, and a rotate can flip it
    // after load, so listen on both rather than picking one at init.
    var pw = document.querySelector('.page-wrapper');
    if (pw) pw.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* --------------------------------------------------------- mega menu */
  function initMega() {
    var items = $$('.aj-nav__item[data-mega]');
    if (!items.length) return;
    var closeTimer;

    function closeAll() {
      items.forEach(function (it) {
        it.classList.remove('is-open');
        var panel = document.getElementById(it.getAttribute('data-mega'));
        if (panel) panel.classList.remove('is-open');
        var link = $('.aj-nav__link', it);
        if (link) link.setAttribute('aria-expanded', 'false');
      });
    }

    items.forEach(function (it) {
      var panel = document.getElementById(it.getAttribute('data-mega'));
      var link = $('.aj-nav__link', it);
      if (!panel || !link) return;

      function open() {
        clearTimeout(closeTimer);
        closeAll();
        it.classList.add('is-open');
        panel.classList.add('is-open');
        link.setAttribute('aria-expanded', 'true');
      }
      function scheduleClose() { closeTimer = setTimeout(closeAll, 140); }

      it.addEventListener('mouseenter', open);
      it.addEventListener('mouseleave', scheduleClose);
      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      panel.addEventListener('mouseleave', scheduleClose);
      link.addEventListener('focus', open);
      link.addEventListener('click', function (e) {
        // first click opens the panel, second follows the link
        if (!it.classList.contains('is-open')) { e.preventDefault(); open(); }
      });
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    var header = $('.aj-header');
    if (header) {
      header.addEventListener('focusout', function (e) {
        if (!header.contains(e.relatedTarget)) closeAll();
      });
    }
  }

  /* ------------------------------------------------------ overlay core */
  var openPanels = [];
  function scrim() {
    var s = $('.aj-scrim');
    if (!s) {
      s = document.createElement('div');
      s.className = 'aj-scrim';
      // The scrim MUST live in the same stacking context as the drawers.
      // #header-group carries a z-index (it is the sticky nav), which makes it
      // a stacking context — so the drawers' z-index:110 is resolved *inside*
      // it. A scrim appended to <body> then sits in the root context at 100,
      // above the whole group, and paints its blur over the open drawer while
      // swallowing every click meant for the menu.
      var host = document.getElementById('header-group') || document.body;
      host.appendChild(s);
      s.addEventListener('click', closePanels);
    }
    return s;
  }
  function openPanel(sel) {
    var el = typeof sel === 'string' ? $(sel) : sel;
    if (!el) return;
    closePanels();
    el.classList.add('is-open');
    scrim().classList.add('is-open');
    lockScroll(true);
    openPanels.push(el);
    var f = el.querySelector('input:not([type=hidden]), button, a');
    if (f) setTimeout(function () { try { f.focus(); } catch (e) {} }, 320);
  }
  function closePanels() {
    openPanels.forEach(function (el) { el.classList.remove('is-open'); });
    openPanels = [];
    var s = $('.aj-scrim');
    if (s) s.classList.remove('is-open');
    lockScroll(false);
  }
  window.AJclosePanels = closePanels;

  function initOverlays() {
    scrim();
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-aj-open]');
      if (opener) { e.preventDefault(); openPanel(opener.getAttribute('data-aj-open')); return; }
      if (e.target.closest('[data-aj-close]')) { e.preventDefault(); closePanels(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(); });
  }

  /* --------------------------------------------------------- mobile nav */
  function initMobileNav() {
    $$('.aj-mnav__item').forEach(function (item) {
      var btn = $('.aj-mnav__top', item);
      if (!btn || btn.tagName === 'A') return;
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------------------------------------------------- footer accordion */
  function initFooter() {
    $$('.aj-footer__toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var col = btn.closest('.aj-footer__col');
        var open = col.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* --------------------------------------------------------------- rails */
  function initRails(root) {
    $$('.aj-rail-wrap', root || document).forEach(function (wrap) {
      if (wrap.dataset.ajRailReady) return;
      wrap.dataset.ajRailReady = '1';
      var rail = $('.aj-rail', wrap);
      var scope = wrap.closest('.shopify-section') || document;
      var prev = $('[data-aj-rail="prev"]', scope);
      var next = $('[data-aj-rail="next"]', scope);
      if (!rail || !prev || !next) return;
      function step() { return rail.clientWidth * 0.8; }
      function sync() {
        prev.disabled = rail.scrollLeft < 8;
        next.disabled = rail.scrollLeft > rail.scrollWidth - rail.clientWidth - 8;
      }
      prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ------------------------------------------------------------ wishlist */
  var WISH_KEY = 'aj_wishlist';
  function readWish() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; }
  }
  function writeWish(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
    var badge = $('[data-aj-wish-count]');
    if (badge) { badge.textContent = list.length; badge.style.display = list.length ? '' : 'none'; }
  }
  function initWishlist() {
    var list = readWish();
    writeWish(list);
    $$('[data-aj-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-aj-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-aj-wish]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-aj-wish');
      var cur = readWish();
      var i = cur.indexOf(handle);
      if (i > -1) { cur.splice(i, 1); } else { cur.push(handle); }
      writeWish(cur);
      var on = i === -1;
      $$('[data-aj-wish="' + handle + '"]').forEach(function (b) {
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      toast(on ? (CFG.t_wish_added || 'Saved to wishlist') : (CFG.t_wish_removed || 'Removed from wishlist'));
    });
  }

  /* ---------------------------------------------------------------- cart */
  var cartState = null;

  function renderCart(cart) {
    cartState = cart;
    var body = $('[data-aj-cart-body]');
    var foot = $('[data-aj-cart-foot]');
    if (!body) return;

    var countEl = $('[data-aj-cart-heading-count]');
    if (countEl) countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="aj-cart-empty">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 8h12l1 12H5L6 8Z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>' +
          '<p>' + (CFG.t_cart_empty || 'Your bag is empty.') + '</p>' +
          '<p class="aj-cart-empty__sub">' + (CFG.t_cart_empty_sub || 'Explore new arrivals to get started.') + '</p>' +
          '<a class="aj-btn" href="' + (CFG.routes_all || '/collections/all') + '">Start shopping</a>' +
        '</div>';
      if (foot) foot.style.display = 'none';
    } else {
      body.innerHTML = cart.items.map(function (l) {
        var img = l.image
          ? l.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')
          : (CFG.placeholder || '');
        var opts = (l.options_with_values || [])
          .filter(function (o) { return o.value && o.value !== 'Default Title'; })
          .map(function (o) { return o.value; }).join(' / ');
        var safeTitle = (l.product_title || '').replace(/"/g, '&quot;');
        // Struck-through original only when this line is actually discounted.
        var discounted = l.original_line_price > l.final_line_price;
        // With more than one unit the line total alone is ambiguous, so show
        // what a single unit costs underneath it.
        var unit = l.quantity > 1 ? '<span class="aj-cart-line__unit">' + money(l.final_price) + ' each</span>' : '';

        return '<div class="aj-cart-line" data-aj-line="' + l.key + '">' +
          '<a class="aj-cart-line__media" href="' + l.url + '" tabindex="-1" aria-hidden="true">' +
            '<img src="' + img + '" alt="" width="84" height="112" loading="lazy">' +
          '</a>' +
          '<div class="aj-cart-line__body">' +
            '<div class="aj-cart-line__top">' +
              '<p class="aj-cart-line__title"><a href="' + l.url + '">' + l.product_title + '</a></p>' +
              '<button class="aj-cart-line__x" type="button" data-aj-remove aria-label="Remove ' + safeTitle + ' from your bag">' +
                '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
              '</button>' +
            '</div>' +
            (opts ? '<p class="aj-cart-line__variant">' + opts + '</p>' : '') +
            '<div class="aj-cart-line__row">' +
              '<span class="aj-qty">' +
                '<button type="button" data-aj-qty="-1" aria-label="Decrease quantity of ' + safeTitle + '">−</button>' +
                '<span aria-live="polite">' + l.quantity + '</span>' +
                '<button type="button" data-aj-qty="1" aria-label="Increase quantity of ' + safeTitle + '">+</button>' +
              '</span>' +
              '<span class="aj-cart-line__price">' +
                (discounted ? '<s>' + money(l.original_line_price) + '</s> ' : '') +
                money(l.final_line_price) + unit +
              '</span>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');
      if (foot) {
        foot.style.display = '';
        var totalEl = $('[data-aj-cart-total]');
        if (totalEl) totalEl.textContent = money(cart.total_price);
        var shipEl = $('[data-aj-cart-ship]');
        if (shipEl) {
          var threshold = parseInt(CFG.freeShipping, 10) || 0;
          if (!threshold) {
            shipEl.style.display = 'none';
          } else {
            shipEl.style.display = '';
            var left = threshold - cart.total_price;
            var pct = Math.max(0, Math.min(100, Math.round((cart.total_price / threshold) * 100)));
            shipEl.innerHTML =
              '<span class="aj-cart-ship__text">' +
                (left > 0
                  ? (CFG.t_ship_progress || 'Spend [amount] more for free standard shipping').replace('[amount]', '<b>' + money(left) + '</b>')
                  : '<b>' + (CFG.t_ship_unlocked || 'Free standard shipping unlocked') + '</b>') +
              '</span>' +
              '<span class="aj-cart-ship__bar' + (left > 0 ? '' : ' is-complete') + '" role="progressbar" ' +
                'aria-valuenow="' + pct + '" aria-valuemin="0" aria-valuemax="100" ' +
                'aria-label="' + (CFG.t_free_ship_goal || 'Free shipping') + '">' +
                '<i style="width:' + pct + '%"></i>' +
              '</span>';
          }
        }
      }
    }

    $$('[data-aj-cart-count]').forEach(function (b) {
      b.textContent = cart.item_count;
      b.style.display = cart.item_count ? '' : 'none';
    });
  }

  function fetchCart() {
    return fetch(CFG.routes_cart ? CFG.routes_cart + '.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function changeLine(key, qty) {
    var body = $('[data-aj-cart-body]');
    if (body) body.classList.add('aj-cart-loading');
    return fetch((CFG.routes_cart_change || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () { toast(CFG.t_error || 'Something went wrong'); })
      .finally(function () { if (body) body.classList.remove('aj-cart-loading'); });
  }

  function addVariant(variantId, qty) {
    return fetch((CFG.routes_cart_add || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message); });
      return r.json();
    });
  }

  function initCart() {
    if (!$('[data-aj-cart-body]')) return;
    fetchCart();

    document.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-aj-qty]');
      if (qtyBtn) {
        var line = qtyBtn.closest('[data-aj-line]');
        var key = line.getAttribute('data-aj-line');
        var item = (cartState && cartState.items || []).filter(function (l) { return l.key === key; })[0];
        if (item) changeLine(key, item.quantity + parseInt(qtyBtn.getAttribute('data-aj-qty'), 10));
        return;
      }
      var rm = e.target.closest('[data-aj-remove]');
      if (rm) {
        changeLine(rm.closest('[data-aj-line]').getAttribute('data-aj-line'), 0)
          .then(function () { toast(CFG.t_removed || 'Removed from bag'); });
        return;
      }
      var add = e.target.closest('[data-aj-add]');
      if (add) {
        e.preventDefault();
        var vid = add.getAttribute('data-aj-add');
        if (!vid) return;
        add.disabled = true;
        addVariant(vid, 1)
          .then(function () { return fetchCart(); })
          .then(function () { openPanel('#aj-cart-drawer'); })
          .catch(function (err) { toast(err.message || (CFG.t_error || 'Something went wrong')); })
          .finally(function () { add.disabled = false; });
      }
    });

    // keep in sync with Horizon's own cart updates (PDP add-to-cart etc.)
    ['cart:update', 'cart:updated', 'cart:refresh'].forEach(function (evt) {
      document.addEventListener(evt, function () { fetchCart(); });
    });
  }

  /* -------------------------------------------------------------- search */
  function initSearch() {
    var input = $('[data-aj-search-input]');
    var results = $('[data-aj-search-results]');
    var suggest = $('.aj-search__suggest');
    if (!input || !results) return;
    var timer, controller;

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) {
        results.innerHTML = '';
        if (suggest) suggest.style.display = '';
        return;
      }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        // Hold the panel in a settled state while the request is in flight —
        // otherwise the suggestions vanish and leave an empty box mid-type.
        if (suggest) suggest.style.display = 'none';
        results.innerHTML =
          '<div class="aj-search__loading" role="status" aria-live="polite">' +
            '<span class="aj-search__spinner" aria-hidden="true"></span>' +
            '<span>' + (CFG.t_searching || 'Searching…') + '</span>' +
          '</div>';
        var url = (CFG.routes_predictive || '/search/suggest') +
          '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page&resources[limit]=8' +
          '&resources[options][unavailable_products]=last';
        fetch(url, { signal: controller.signal, headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var res = (data.resources && data.resources.results) || {};
            var hits = res.products || [];
            var colls = res.collections || [];
            var pages = res.pages || [];
            if (suggest) suggest.style.display = 'none';

            if (!hits.length && !colls.length && !pages.length) {
              results.innerHTML =
                '<div class="aj-search__empty">' +
                  '<p>' + (CFG.t_no_results || 'No products match') + ' “' + q.replace(/</g, '&lt;') + '”.</p>' +
                  '<p class="aj-search__empty-sub">Check the spelling, or try a broader term like “jacket” or “gold”.</p>' +
                '</div>';
              return;
            }

            var html = '';
            if (colls.length || pages.length) {
              html += '<div class="aj-search__quick">' +
                colls.concat(pages).slice(0, 6).map(function (c) {
                  return '<a class="aj-chip" href="' + c.url + '">' + c.title + '</a>';
                }).join('') + '</div>';
            }
            if (hits.length) {
              html += '<h3 class="aj-eyebrow" style="margin:0 0 16px">' + hits.length + ' ' +
                (hits.length === 1 ? (CFG.t_product || 'product') : (CFG.t_products || 'products')) + '</h3>' +
                '<div class="aj-search__results-grid">' + hits.map(function (p) {
                  var img = p.featured_image && p.featured_image.url
                    ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
                  // Predictive search returns price as a decimal STRING in shop
                  // currency ("35.03"), not cents — parseInt would render that
                  // as $0.35, so scale it before handing it to money().
                  var cents = p.price ? Math.round(parseFloat(p.price) * 100) : null;
                  return '<a class="aj-search__hit" href="' + p.url + '">' +
                    (img ? '<img src="' + img + '" alt="" width="72" height="96" loading="lazy">' : '<span class="aj-search__noimg"></span>') +
                    '<span class="aj-search__hit-body">' +
                      '<strong>' + p.title + '</strong>' +
                      '<span>' + (cents === null || isNaN(cents) ? '' : money(cents)) + '</span>' +
                    '</span></a>';
                }).join('') + '</div>';
            }
            html += '<p style="margin-top:24px"><a class="aj-link-u" href="' + (CFG.routes_search || '/search') +
              '?q=' + encodeURIComponent(q) + '">' + (CFG.t_view_all || 'View all results') + '</a></p>';
            results.innerHTML = html;
          })
          .catch(function (err) { if (err.name !== 'AbortError') results.innerHTML = ''; });
      }, 220);
    });
  }

  /* ------------------------------------------------------- scroll reveal */
  function initReveal() {
    var targets = $$('[data-aj-reveal]');
    if (!targets.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.Shopify && window.Shopify.designMode) return; // never hide content in the editor

    function show(el) { el.style.opacity = '1'; el.style.transform = 'none'; }
    targets.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(18px)';
      el.style.transition = 'opacity .7s cubic-bezier(.22,.61,.36,1), transform .7s cubic-bezier(.22,.61,.36,1)';
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { show(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });
    // hard fallback — content must never stay invisible
    setTimeout(function () {
      targets.forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 1.5) show(el);
      });
    }, 1500);
  }

  /* ------------------------------------------------------------ newsletter */
  function initNewsletter() {
    $$('.aj-newsletter').forEach(function (sec) {
      if (sec.querySelector('.aj-newsletter__done[data-posted]')) {
        var form = sec.querySelector('.aj-newsletter__form');
        if (form) form.style.display = 'none';
      }
    });
  }

  /* --------------------------------------------------- collection filters */
  function initCollection() {
    var form = document.getElementById('aj-filter-form');
    var sort = $('[data-aj-sort]');

    // dropdown open/close
    $$('.aj-filter').forEach(function (f) {
      var btn = $('.aj-filter__btn', f);
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var was = f.classList.contains('is-open');
        $$('.aj-filter').forEach(function (o) { o.classList.remove('is-open'); });
        f.classList.toggle('is-open', !was);
        btn.setAttribute('aria-expanded', !was ? 'true' : 'false');

        // The filter row sits well down the page, so a panel that opens in
        // flow can land under the fold — or under Safari's bottom bar and the
        // Shopify preview bar, which overlay the viewport without being part
        // of it. Centring the panel clears both ends reliably.
        if (!was) {
          var panel = $('.aj-filter__panel', f);
          if (panel && panel.scrollIntoView) {
            // Called straight away, not inside requestAnimationFrame:
            // scrollIntoView forces layout itself, so the panel's new position
            // is already correct, and rAF callbacks are throttled or dropped
            // entirely in background/non-compositing renderers — which would
            // leave the panel off screen exactly where it matters.
            // Instant rather than smooth for the same reliability reason.
            try {
              panel.scrollIntoView({ block: 'center', behavior: 'auto' });
            } catch (err) {
              panel.scrollIntoView();
            }
          }
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.aj-filter')) $$('.aj-filter').forEach(function (o) { o.classList.remove('is-open'); });
    });

    // Filter inputs deliberately do NOT auto-submit — they are collected and
    // applied together by the visible Apply button in the filter row.

    // Sorting is one decisive choice, so it applies on the spot.
    // The listener must sit on the select itself: it lives in .aj-sort, a
    // sibling of the filter form, and is tied to it only by the form=
    // attribute. Change events bubble up the DOM tree, never to a form
    // associated that way — so a listener on the form never sees it, and
    // sorting silently did nothing on every collection that has filters.
    if (sort) {
      sort.addEventListener('change', function () {
        if (form) {
          // form= association means the select's value is submitted with it,
          // and the current filter values ride along unchanged.
          form.submit();
          return;
        }
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  }

  /* ------------------------------------------------------------- product */
  function initPDP() {
    var pdp = $('.aj-pdp');
    if (!pdp) return;

   // gallery
var slides = $$('.aj-pdp__slide', pdp);
var thumbs = $$('.aj-pdp__thumb', pdp);
var index = 0;
var visibleSlides = slides.slice();

function getVariantIds(el) {
  var raw = el.getAttribute('data-aj-variant-ids') || '';
  if (!raw) return [];
  return raw.split(',').map(function (id) {
    return id.trim();
  }).filter(Boolean);
}

function filterGallery(variantId) {
  if (!slides.length) return;

  var variant = String(variantId || '');
  var selectedOption = Array.prototype.slice.call(select.options || []).filter(function (o) {
    return String(o.value) === variant;
  })[0];

  var featuredMediaId = selectedOption
    ? selectedOption.getAttribute('data-featured-media-id')
    : '';

  var matching = [];
  var generic = [];

  slides.forEach(function (slide, n) {
    var mediaId = slide.getAttribute('data-aj-media-id') || '';
    var ids = getVariantIds(slide);

    if (featuredMediaId && mediaId === String(featuredMediaId)) {
      matching.push(n);
      return;
    }

    if (!ids.length) {
      generic.push(n);
    }
  });

  var allowed;

  if (matching.length) {
    // Put the selected variant's featured image first.
    allowed = matching.concat(
      slides.map(function (_, n) {
        return n;
      }).filter(function (n) {
        return matching.indexOf(n) === -1;
      })
    );
  } else {
    allowed = slides.map(function (_, n) {
      return n;
    });
  }

  visibleSlides = allowed.map(function (n) {
    return slides[n];
  });

  slides.forEach(function (slide, n) {
    var visible = allowed.indexOf(n) !== -1;
    slide.hidden = !visible;
    slide.classList.toggle('is-hidden', !visible);
  });

  thumbs.forEach(function (thumb, n) {
    var visible = allowed.indexOf(n) !== -1;
    thumb.hidden = !visible;
    thumb.classList.toggle('is-hidden', !visible);
  });

  show(0);
}

function show(i) {
  if (!visibleSlides.length) return;

  index = (i + visibleSlides.length) % visibleSlides.length;

  visibleSlides.forEach(function (slide, n) {
    slide.classList.toggle('is-active', n === index);
  });

  thumbs.forEach(function (thumb) {
    thumb.classList.remove('is-active');
  });

  var activeSlide = visibleSlides[index];
  if (!activeSlide) return;

  var activeIndex = slides.indexOf(activeSlide);
  var activeThumb = thumbs[activeIndex];

  if (activeThumb) {
    activeThumb.classList.add('is-active');

    if (activeThumb.scrollIntoView) {
      activeThumb.scrollIntoView({
        block: 'nearest',
        inline: 'nearest'
      });
    }
  }
}

thumbs.forEach(function (t) {
  t.addEventListener('click', function () {
    var originalIndex = parseInt(
      t.getAttribute('data-aj-thumb'),
      10
    );

    var visibleIndex = visibleSlides.indexOf(slides[originalIndex]);

    if (visibleIndex !== -1) {
      show(visibleIndex);
    }
  });
});

$$('[data-aj-slide-nav]', pdp).forEach(function (b) {
  b.addEventListener('click', function () {
    show(
      index + parseInt(
        b.getAttribute('data-aj-slide-nav'),
        10
      )
    );
  });
});

    // share — native share sheet where available, clipboard otherwise
    var share = $('[data-aj-share]', pdp);
    if (share) {
      share.addEventListener('click', function () {
        var url = share.getAttribute('data-aj-share');
        if (navigator.share) {
          navigator.share({ title: document.title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () { toast('Link copied'); });
        }
      });
    }

    // Add to cart without leaving the page — post the form over AJAX and
    // open the drawer, instead of Shopify's default redirect to /cart.
    var form = $('#aj-product-form', pdp) || pdp.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('[data-aj-atc]', form);
        var original = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = CFG.t_adding || 'Adding…'; }

        fetch((CFG.routes_cart_add || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) {
            return r.json().then(function (j) {
              if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag');
              return j;
            });
          })
          .then(function () {
            return fetchCart();
          })
          .then(function () {
            openPanel('#aj-cart-drawer');
            document.dispatchEvent(new CustomEvent('cart:updated'));
          })
          .catch(function (err) { toast(err.message); })
          .finally(function () {
            if (btn) { btn.disabled = false; btn.textContent = original; }
          });
      });
    }

    // quantity
    var qtyInput = $('[data-aj-pdp-qty-input]', pdp);
    $$('[data-aj-pdp-qty]', pdp).forEach(function (b) {
      b.addEventListener('click', function () {
        var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-aj-pdp-qty'), 10);
        qtyInput.value = Math.max(1, next);
      });
    });

    // variants — map the option chips onto the hidden variant <select>
    var select = $('[data-aj-variant-select]', pdp);
    if (!select) return;
    var priceEl = $('[data-aj-price]', pdp);
    var stockEl = $('[data-aj-stock]', pdp);
    var atc = $('[data-aj-atc]', pdp);

    function sync() {
      var chosen = $$('.aj-opt', pdp).map(function (opt) {
        var checked = opt.querySelector('input[data-aj-option-input]:checked');
        var label = $('[data-aj-option-value]', opt);
        if (checked && label) label.textContent = checked.value;
        return checked ? checked.value : '';
      }).join(' / ');

      var match = Array.prototype.slice.call(select.options).filter(function (o) {
        return o.getAttribute('data-options') === chosen;
      })[0];
      if (!match) return;

select.value = match.value;

var featuredMediaId = match.getAttribute('data-featured-media-id');

if (featuredMediaId) {
  var featuredSlide = slides.filter(function (slide) {
    return slide.getAttribute('data-aj-media-id') === featuredMediaId;
  })[0];

  if (featuredSlide) {
    var featuredIndex = visibleSlides.indexOf(featuredSlide);

    if (featuredIndex !== -1) {
      show(featuredIndex);
    } else {
      visibleSlides = slides.slice();
      show(slides.indexOf(featuredSlide));
    }
  }
}

      var price = match.getAttribute('data-price');
      var compare = match.getAttribute('data-compare');
      if (priceEl && price) {
        priceEl.innerHTML = compare
          ? '<span class="aj-prod__now">' + price + '</span><span class="aj-prod__was">' + compare + '</span>'
          : '<span>' + price + '</span>';
      }

      var available = match.getAttribute('data-available') === 'true';
      if (atc) {
        atc.disabled = !available;
        atc.textContent = available ? (CFG.t_add || 'Add to bag') : 'Sold out';
      }
      if (stockEl) {
        stockEl.innerHTML = available
          ? '<span class="aj-dot aj-dot--in"></span> In stock, ready to ship'
          : '<span class="aj-dot aj-dot--out"></span> Currently unavailable';
      }

      // keep the URL shareable
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.value);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

   pdp.addEventListener('change', function (e) {
  if (e.target.matches('input[data-aj-option-input]')) {
    sync();
  }
});

// Apply the currently selected variant when the product page loads.
sync();
  }

  /* ---------------------------------------------------------------- FAQ */
  function initFAQ() {
    var input = $('[data-aj-faq-search]');
    var wrap = $('[data-aj-faq]');
    if (!input || !wrap) return;
    var items = $$('.aj-faq__item', wrap);
    var cats = $$('.aj-faq__cat', wrap);
    var none = $('[data-aj-faq-none]', wrap);

    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var shown = 0;
      items.forEach(function (item) {
        var hit = !q || item.textContent.toLowerCase().indexOf(q) > -1;
        item.hidden = !hit;
        if (hit) shown++;
      });
      cats.forEach(function (c) { c.hidden = !!q; });
      if (none) none.hidden = shown > 0;
    });
  }

  /* ---------------------------------------------------------------- boot */
  function boot() {
    initCollection();
    initPDP();
    initFAQ();
    initAnnounce();
    initHeader();
    initMega();
    initOverlays();
    initMobileNav();
    initFooter();
    initRails();
    initWishlist();
    initCart();
    initSearch();
    initNewsletter();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: re-init whatever was just re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    initRails(e.target);
    initAnnounce();
    initHeader();
    initMega();
    initMobileNav();
    initFooter();
    initSearch();
    initCart();
    initCollection();
    initPDP();
    initFAQ();
  });
})();
